import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../../logo.png";
import { SiteName } from "../../global/SiteName";
import GlobalStyles, { CommonClasses } from "../../global/GlobalStyles";
import DarkModeToggle from "../darkMode/DarkModeToggle";
import MenuToggleButton from "./components/MenuToggleButton";
import { useSelector } from "react-redux";

const HomeNavbar = () => {
  const user = useSelector((state) => state.user.profile);
  const [isOpen, setIsOpen] = useState(false);
  const navLinks = [
    { name: "Home", path: "/" },
    { name: "Track", path: "/track" },
    { name: "Ship", path: "/ship" },
    { name: "Customer Service", path: "/support" },
    { name: "About Us", path: "/about-us" },
  ];

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className={GlobalStyles.navbarWrapper}>
      <div className={GlobalStyles.navbarContainer}>
        <Link className={GlobalStyles.navbarBrand} to="/">
          <img src={logo} alt="logo" className={GlobalStyles.navbarLogo} />
          <span className={GlobalStyles.navbarLogoText}>{SiteName}</span>
        </Link>
        <div className="flex gap-5 max-md:hidden items-center">
          {navLinks.map((link, index) => (
            <Link
              key={index}
              to={link.path}
              className={GlobalStyles.navbarLink}
            >
              {link.name}
            </Link>
          ))}
        </div>
        <div className="flex items-center gap-5">
          {user && (
            <Link to={`/admin/dashboard`} className={GlobalStyles.button}>
              Dashboard
            </Link>
          )}
          <DarkModeToggle />
          <MenuToggleButton isOpen={isOpen} toggleMenu={toggleMenu} />
        </div>
        <div
          className={`w-full absolute bg-light dark:bg-dark md:hidden flex flex-col top-16 left-0 ${
            CommonClasses.transition
          } ${isOpen ? "h-[12rem]" : "h-0"}`}
        >
          {navLinks.map((item) => (
            <Link
              to={item.path}
              className={`px-3 flex items-center text-primary text-sm ${
                CommonClasses.transition
              } ${
                isOpen ? "h-[3rem]" : "h-0 border-transparent"
              }  overflow-hidden hover:bg-primary/20`}
              key={item.name}
              onClick={() => setIsOpen(false)}
            >
              {item.name}
            </Link>
          ))}
        </div>
      </div>
    </nav>
  );
};

export default HomeNavbar;
